import { Link } from "react-router-dom";
import classes from "./Status.module.css";

const StatusPage = (props) => {
  return (
    <div className={classes.wrapper}>
      {props.type === "success" ? (
        <div className={classes.body}>
          <img
            className={classes.icon}
            src="/assets/images/icons/success.svg"
            alt="Успешная оплата"
          />
          <h1 className={classes.title}>Заказ успешно оплачен!</h1>
          <Link to="/" className={classes.button}>
            Перейти на главную
          </Link>
        </div>
      ) : (
        <div className={classes.body}>
          <img
            className={`${classes.icon} ${classes.icon_error}`}
            src="/assets/images/icons/fail.svg"
            alt="Неуспешная оплата"
          />
          <h1 className={classes.title}>Ошибка при оплате заказа!</h1>
          <Link to="/" className={classes.button}>
            Перейти на главную
          </Link>
        </div>
      )}
    </div>
  );
};

export default StatusPage;
